import { render, staticRenderFns } from "./CouponTitle.vue?vue&type=template&id=aa46511a&scoped=true&"
import script from "./CouponTitle.vue?vue&type=script&lang=ts&"
export * from "./CouponTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CouponTitle.vue?vue&type=style&index=0&id=aa46511a&lang=scss&scoped=true&"
import style1 from "./CouponTitle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa46511a",
  null
  
)

export default component.exports